import React from "react";
import PanelGroupController from "../../../components/PanelGroupController";
import {fromJS} from "immutable";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {Query} from "react-apollo";
import InlineTable from "../../../components/InlineTable";
import {GET_BUNDLED_PRODUCTS} from "../../../queries/inventory";

const FIELDS = fromJS([
  { field: "quantity", title: "Qty." },
  { field: "productSku", title: "Product" },
  { field: "productTitle", title: "Title"}
])

const BundledProductsPanel = (props) => {

  let elements = null;
  if (!props.active) {
    elements = <p className="u-no-selection">Nothing selected, or product not a bundle</p>
  } else {
    let variables = {bundle_sku: props.productId}
    elements = (
      <Query query={GET_BUNDLED_PRODUCTS} variables={variables} skip={!props.active} fetchPolicy="network-only">
        {({ loading, error, data }) => {
          if (loading) return <Loading />
          if (error) return <GraphQLErrors error={error} />
          return (
            <InlineTable
              data={fromJS(data.bundledProduct)}
              fields={FIELDS}
              dataType="bundled_product"
              />
          )
        }}
      </Query>
    )
  }

  return (
    <PanelGroupController title="Bundled Products" expanded={props.expanded}>
      {elements}
    </PanelGroupController>
  )

}

BundledProductsPanel.defaultProps = {
  active: true
}

export default BundledProductsPanel;